import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useIntl } from "react-intl";

//Components
import { Grid, Typography, Container, Paper, Divider } from "@mui/material";
import { Button } from "@gpstrackit/react-controls"


//EndPoints
import { endpoints } from 'Core/defaultValues';

//Views
import DataView from 'Components/DataView';
import EditBrand from '../.components/editBrand';
import DeleteBrand from '../.components/deleteBrand'

//Security
import { HasPermission } from "Core/security";

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    brandsEditBrandOpenModal,
    brandDeleteOpenModal,
} from 'Redux/actions';
import { ca } from "date-fns/locale";

const BrandsMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();


    const editBrandOModal = useSelector(state => state.editBrandRedux.openModal);
    const deleteBrandOModal = useSelector(state => state.deleteBrandRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const [columns, setColumns] = useState([

        {
            key: "id",
            title: messages['brands_main_id'],
            width: 25,
            show: true,
            sort: true,
            locked: true,
            resize: true,
            export: true,
            functionString: 'return row?.id',
            code: "brands_main_id",
            render: (item) => {
                return <span>{item?.id}</span>
            }
        },
        {
            key: "code",
            field: "code",
            title: messages['brands_main_code'],
            width: 130,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "brands_main_code",
            render: (item) => {
                return <span>{item?.code}</span>
            },
            export: true,
            functionString: 'return row?.code'
        },
        {
            key: "title",
            field: "title",
            title: messages['brands_main_name'],
            width: 200,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            code: "brands_main_name",
            render: (item) => {
                let name = item?.title
                if (name?.length >= 40) {
                    name = name?.substring(0, 40) + "...";
                }
                return (
                    <NavLink to={`/app/brands/overview/${item?.id}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{name}</span>
                    </NavLink>
                )
            },
            export: true,
            functionString: 'return row?.title'
        },
        {
            key: "domains",
            field: "domains",
            title: messages['brands_main_domains'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_domains",
            render: (item) => {
                let domains = item?.domains;
                if (domains?.length > 0) {
                    try {
                        domains = JSON.parse(JSON.parse(domains));
                        if(!Array.isArray(domains)) {
                            domains = JSON.parse(domains);
                        }
                    } catch (e) {
                        console.log("Error parsing domains", e);
                    }
                }
                
                if (domains?.length > 0) {
                    return (
                        <span>
                            {domains?.map((item, index) => {
                                return (
                                    <a
                                        style={{ marginRight: 10, color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={(e) => {
                                            window.open(`https://${item}`, '_blank');
                                        }}
                                    >
                                        {item}
                                    </a>
                                )
                            })}
                        </span>
                    )
                } else {
                    return <span></span>
                }

            },
            export: true,
            functionString: 'return row?.domains'
        },
        {
            key: "homePageUrl",
            field: "homePageUrl",
            title: messages['brands_main_home_page'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_home_page",
            render: (item) => {
                let homePageUrl = item?.homePageUrl;
                if (homePageUrl?.length > 0) {
                    if (homePageUrl?.includes("http") === false) {
                        homePageUrl = `https://${homePageUrl}`;
                    }
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(homePageUrl, '_blank');
                            }}
                        >
                            {homePageUrl}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.homePageUrl'
        },
        {
            key: "tosUrl",
            field: "tosUrl",
            title: messages['brands_main_tos_url'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_tos_url",
            render: (item) => {
                let tosUrl = item?.tosUrl;
                if (tosUrl?.length > 0) {
                    if (tosUrl?.includes("http") === false) {
                        tosUrl = `https://${tosUrl}`;
                    }
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(tosUrl, '_blank');
                            }}
                        >
                            {tosUrl}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.tosUrl'
        },
        {
            key: "helpUrl",
            field: "helpUrl",
            title: messages['brands_main_help_url'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_help_url",
            render: (item) => {
                let helpUrl = item?.helpUrl;
                if (helpUrl?.length > 0) {
                    if (helpUrl?.includes("http") === false) {
                        helpUrl = `https://${helpUrl}`;
                    }
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(helpUrl, '_blank');
                            }}
                        >
                            {helpUrl}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.helpUrl'
        },
        {
            key: "address",
            field: "address",
            title: messages['brands_main_address'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_address",
            render: (item) => {
                let address = item?.address;
                if (address?.length > 0) {
                    return (
                        <span>
                            {address}
                        </span>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.address'
        },
        {
            key: "phone",
            field: "phone",
            title: messages['brands_main_phone'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_phone",
            render: (item) => {
                let phone = item?.phone;
                if (phone?.length > 0) {
                    return (
                        <span>
                            {phone}
                        </span>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.phone'
        },
        {
            key: "loginBackgroundImage",
            field: "loginBackgroundImage",
            title: messages['brands_main_login_background_image'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_login_background_image",
            render: (item) => {
                let loginBackgroundImage = item?.loginBackgroundImage;
                if (loginBackgroundImage?.length > 0) {
                    if (loginBackgroundImage?.includes("http") === false) {
                        loginBackgroundImage = `https://${loginBackgroundImage}`;
                    }
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(loginBackgroundImage, '_blank');
                            }}
                        >
                            {loginBackgroundImage}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
        },
        {
            key: "loginBackgroundColor",
            field: "loginBackgroundColor",
            title: messages['brands_main_login_background_color'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_login_background_color",
            render: (item) => {
                let loginBackgroundColor = item?.loginBackgroundColor;
                if (loginBackgroundColor?.length > 0) {
                    return (
                        <span>
                            <input type="color" id="head" name="head" value={loginBackgroundColor} disabled />
                        </span>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.loginBackgroundColor'
        },
        {
            key: "loginCompanyLogo",
            field: "loginCompanyLogo",
            title: messages['brands_main_login_company_logo'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_login_company_logo",
            render: (item) => {
                let loginCompanyLogo = item?.loginCompanyLogo;
                if (loginCompanyLogo?.length > 0) {
                    if (loginCompanyLogo?.includes("http") === false) {
                        loginCompanyLogo = `https://${loginCompanyLogo}`;
                    }
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(loginCompanyLogo, '_blank');
                            }}
                        >
                            {loginCompanyLogo}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.loginCompanyLogo'
        },
        {
            key: "favicon",
            field: "favicon",
            title: messages['brands_main_favicon'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_favicon",
            render: (item) => {
                let favicon = item?.favicon;
                if (favicon?.length > 0) {
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(favicon, '_blank');
                            }}
                        >
                            {favicon}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.favicon'
        },
        {
            key: "inAppLogo",
            field: "inAppLogo",
            title: messages['brands_main_in_app_logo'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            code: "brands_main_in_app_logo",
            render: (item) => {
                let inAppLogo = item?.inAppLogo;
                if (inAppLogo?.length > 0) {
                    return (
                        <a
                            style={{ color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={(e) => {
                                window.open(inAppLogo, '_blank');
                            }}
                        >
                            {inAppLogo}
                        </a>
                    )
                } else {
                    return <span></span>
                }
            },
            export: true,
            functionString: 'return row?.inAppLogo'
        }
    ])
    const [searchFields, setSearchFields] = useState(["code", "title"]);
    const [total, setTotal] = useState(0);

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['brands_main_brands']} ({total})
                        </Typography>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataView
                        ref={tableRef}
                        exportName="brands"
                        dinamicQuery
                        name="pm-brands"
                        entity="brands"
                        graphqlFunction="searchBrands"
                        graphqlSort="BrandSortInput"
                        graphqlConditions="BrandSearchInput"
                        customQuery="id"
                        columns={columns}
                        hideAllInPagination
                        noFilters
                        asyncSelect
                        searchConditions={["code", "title"]}
                        searchOptionValue="id"
                        searchOptionLabel="title"
                        onChangeConditions={(tags, conditions, total, newColumns, rows, sort) => {
                            //current conditions
                            let currentConditions = {}
                            let currentTags = {}

                            if (!conditions && tags) {
                                currentConditions = tableRef?.current?.conditions;
                                currentTags = tags;
                            } else {
                                currentConditions = conditions || [];
                                currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
                                if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
                            }

                            currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'code' && item?.fields[0] !== 'templateCode');

                            let tagsById = currentTags.filter((item) => typeof item.id === "number");
                            if (tagsById?.length > 0) {
                                //New Items
                                let currentIds = tagsById.map((item) => (item.id));
                                if (currentIds.length > 0) {
                                    currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: currentTags, conditionOperator: "OR" });
                                }
                            }

                            let tagsByLabel = currentTags.filter((item) => typeof item.id === "string");
                            if (tagsByLabel.length > 0) {
                                let currentLabels = tagsByLabel.map((item) => (item.title))
                                if (currentLabels.length > 0) {
                                    currentConditions.push({ fields: searchFields, terms: currentLabels, exact: false, tags: currentTags, conditionOperator: "OR" })
                                }
                            }

                            if (!conditions && tags) tableRef?.current?.getData(null, null, null, currentConditions);
                            else tableRef?.current?.getData(null, rows, sort, currentConditions, newColumns);
                        }}
                        topheight={200}
                        onChangeTotal={(total) => setTotal(total)}
                        onFilters={() => { setOpenPanel(!openPanel) }}
                        noSplit
                        onChangeColumns={(items) => {
                            let currentColumns = items.map((item) => ({
                                ...item,
                                title: item.code ? messages[item.code] : item.title
                            }))
                            setColumns(currentColumns)
                        }}
                        tableButtons={["export", 'orderColumn']}
                        options={[
                            {
                                id: "brands_main_edit",
                                label: messages['brands_main_edit'],
                                single: true,
                                show: true,
                                disabled: !HasPermission(user, "brnd", "u"),
                                action: (items) => {
                                    let currentItem = items.find(item => item.id);
                                    dispatch(brandsEditBrandOpenModal(currentItem.id))
                                }
                            }
                        ]}
                        menuOptions={() => {
                            return [
                                messages['brands_main_edit'],
                                messages['brands_main_delete_brand'],
                                messages['brands_main_navigate_to_test_page'],
                            ]
                        }}
                        onClickMenu={(event, item) => {

                            if (event === messages['brands_main_edit']) {
                                if (HasPermission(user, "brnd", "u")) {
                                    dispatch(brandsEditBrandOpenModal(item.id))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['brands_main_edit'],
                                        5000,
                                    );
                                }
                            }
                            if (event === messages['brands_main_delete_brand']) {
                                if (HasPermission(user, "brnd", "d")) {
                                    dispatch(brandDeleteOpenModal(item))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['brands_main_delete_brand'],
                                        5000,
                                    );
                                }
                            }
                            if (event === messages['brands_main_navigate_to_test_page']) {
                                window.open(`${endpoints.CLOUD_WEBSITE}/reseller/${item.code}`, '_blank');
                            }

                        }}

                        extraButton={() => {
                            return (
                                <div style={{ margin: '0 5px' }}>
                                    <Button
                                        disabled={!HasPermission(user, "brnd", "c")}
                                        className="btn-dark-blue"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            dispatch(brandsEditBrandOpenModal())
                                        }}
                                    >
                                        {messages['brands_main_add_brand']}
                                    </Button>
                                </div>
                            )
                        }}
                    />
                </Grid>
            </Paper>
            {
                editBrandOModal && <EditBrand tableRef={tableRef} />
            }
            {
                deleteBrandOModal && <DeleteBrand tableRef={tableRef} />
            }
        </Container>
    )
}
export default BrandsMain;